import { BaseEntity } from "yt-ng-framework";

export class Stopa extends BaseEntity{
    constructor(){
        super();
    };

    
    Datum:Date = null;
    TarifaID:number = null;
    Iznos:number = null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Datum=input.Datum;
        this.TarifaID=input.TarifaID;
        this.Iznos=input.Iznos;
        return this;
    }

    Serialize(input:Stopa){
        return input;
    }

}